<template>
    <div class="client-list grid grid__base">
        <div class="client-list--container grid--container">
            <div class="client-list--row grid--row">
                <div class="grid--col client-list--title-col">
                    <h3 class="client-list--title">{{ title }}</h3>
                </div>

                <div class="grid--col client-list--filter-col">
                    <multiselect
                            class="client-list--filter"
                            v-model="selectedFilter"
                            :placeholder="filterPlaceholder"
                            :options="selectOptions">
                        <template slot="singleLabel" slot-scope="props">
                            {{ props.option.label }}
                        </template>

                        <template slot="option" slot-scope="props">
                            <span >{{ props.option.label }}</span>
                        </template>

                    </multiselect>
                </div>
            </div>

            <div class="grid--row client-list--list">
                <client-logo class="grid--col client-list--item"
                        v-for="(item, key) in filteredListItems"
                        v-bind="item"
                        :key="key"/>
            </div>
        </div>
    </div>
</template>

<script>

    import { reduce } from 'lodash';

    import ClientLogo from 'framework/global-components/dyn/client-logo/client-logo';

    export default {

        components: {
            ClientLogo,
        },

        props: {
            title: {
                type: String,
                default: null,
            },

            selectAllLabel: {
                type: String,
                required: true,
            },

            filterPlaceholder: {
                type: String,
                required: true,
            },

            filterOptions: {
                type: Object,
                required: true,
            },

            /**
             * @type {IClientListItem}
             */
            items: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                /** @type {IFilterOption} */
                selectedFilter: null,
            };
        },

        computed: {
            /**
             * Remapped options object
             * @return {IFilterOption[]}
             */
            selectOptions() {
                const options = [{ label: this.selectAllLabel, value: null }];

                return reduce(this.filterOptions, (acc, val, key) => {
                    acc.push({
                        label: val,
                        value: key,
                    });
                    return acc;
                }, options);
            },

            /**
             * Get list of filtered items
             * @return {IClientListItem[]}
             */
            filteredListItems() {
                if (!this.selectedFilter) {
                    return this.items;
                }

                return reduce(this.items, (acc, item) => {
                    if (this.selectedFilter.value === item.industryKey || this.selectedFilter.value === null) {
                        acc.push(item);
                    }
                    return acc;
                }, []);
            },
        },
    };
</script>
